import "./error-page.css"; // Make sure to create this CSS file
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const ErrorPage = ({ error }) => {
  return (
    <div className="error-container">
      <Helmet>
        <title>Send Money with CashOver Pay | Secure & Fast Payments</title>
        <meta
          name="description"
          content="Send money securely and instantly to your friends or businesses with CashOver Pay. Use the app to safely transfer LBP, USD, or USDT to anyone in Lebanon."
        />
        <meta
          property="og:title"
          content="Send Money Securely with CashOver Pay"
        />
        <meta
          property="og:description"
          content="Use CashOver Pay to send funds safely and conveniently. Scan the QR code or follow the link to complete your payment quickly and securely."
        />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SITE_URL}/pay.webp`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <svg
        className="error-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        x="0px"
        y="0px"
      >
        <g>
          <path d="M72.7,13H27.3A8.31,8.31,0,0,0,19,21.3V78.7A8.31,8.31,0,0,0,27.3,87H72.7A8.31,8.31,0,0,0,81,78.7V21.3A8.31,8.31,0,0,0,72.7,13ZM77,78.7A4.31,4.31,0,0,1,72.7,83H27.3A4.31,4.31,0,0,1,23,78.7V21.3A4.31,4.31,0,0,1,27.3,17H72.7A4.31,4.31,0,0,1,77,21.3Z" />
          <path d="M50,25.5a2,2,0,0,0-2,2v31a2,2,0,0,0,4,0v-31A2,2,0,0,0,50,25.5Z" />
          <path d="M50,64.5a2,2,0,0,0-2,2v6a2,2,0,0,0,4,0v-6A2,2,0,0,0,50,64.5Z" />
        </g>
      </svg>

      <h2 className="error-title">Oops!</h2>
      <p className="error-message">{error}</p>

      <Link to="/" className="navigation-bar-general-navlink1">
        <button className="thq-button-outline"> Go Home</button>{" "}
      </Link>
    </div>
  );
};

export default ErrorPage;
